import { fields as userFields } from "@/lib/user/fields";

const { allow_app_push_notifications } = userFields;

export const notificationFields = {
  allow_app_push_notifications,
};
